<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="true"
    :backButtonRoute="backButtonRoute"
    ref="despatch-order"
    :data-model="getDataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :headerScreenJson="getHeaderScreenJson"
    :serverError="serverError"
    :getHeaderToolbar="getHeaderToolbar"
    :itemPriceUpdate="itemPriceUpdate"
    :almondcoDespatchData="almondcoDespatchData"
    :editProductItem="editProductItem"
    :addSalesOrderItem="addSalesOrderItem"
    :refreshDataGridProp="refreshDataGrid"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { FeatureStorage } from "../../_services/storage";
import SalesFormulas from "../../_helpers/formulas/sales-formulas";
import { DespatchOrderService } from "../../_services/api/sales/despatch-order.service";
import { ProductBatchService } from "../../_services/api/inventory/product-batch.service";
import CheckBox from "devextreme/ui/check_box";
import SettingsService from "../../_services/api/settings/graycorp/settings.service";
import { mapGetters } from "vuex";
import { CacheService } from "../../_services/cache/cache-service";

var BranchCode = "";
export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      loaded: false,
      setLoading: false,
      reload: false,
      serverError: {},
      validationSummary: [],
      model: {
        ProcessInvoice: true,
      },
      allBatchData: [],
      itemPriceUpdate: undefined,
      processInvoiceSettingValue: undefined,
      almondcoDespatchData: undefined,
      editProductItem: undefined,
      addSalesOrderItem: undefined,
      despatchOrderLocalDataList: [],
      refreshDataGrid: false,
    };
  },

  async created() {
    BranchCode = "";
    this.setLoading = true;
    this.getProcessInvoiceSetting();
    this.getDespatchOrderDetails();
  },
  async mounted() {
    this.$store.dispatch("dataContext/setReviewDataSource", []);
  },
  beforeDestroy() {
    this.$store.dispatch("dataContext/setReviewDataSource", []);
  },

  computed: {
    ...mapGetters({ getGridContentReady: "ui/getGridContentReady" }),
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    backButtonRoute() {
      return "/despatch-order";
    },
    getScreenJson() {
      var screenJson = {
        title: "Despatch Order",
        endpoint: {
          primary: "PickingSlip",
          filter: `SalesOrderCode eq ${this.baseView.id}`,
          expand:
            "SalesOrderType($select=Code,Description),SalesRepresentative($select=Code,FirstName,Surname),Branch($select=Code,Description),Division($select=Code,Description),Customer($select=Code,Name,CurrencyCode)",
          postProcess: this.despatchOrderPostProcess,
          select: [
            "SalesOrderCode",
            "DateIn",
            "RequiredByDate",
            "ShipDate",
            "OrderNo",
            "CustomerDeliveryAddressLineNo",
            "DeliveryAddressCompanyName",
            "DeliveryAddressCountry",
            "DeliveryAddressPostcode",
            "DeliveryAddressState",
            "DeliveryAddressStreetLine1",
            "DeliveryAddressStreetLine2",
            "DeliveryAddressSuburb",
            "ConsignmentNo",
            "Currency",
            "BranchCode",
            "DivisionCode",
            "SalesOrderTypeCode",
            "SalesRepresentativeCode",
            "Status",
            "CustomerCode",
            "UserComment1",
            "UserComment2",
            "UserComment3",
            "UserComment4",
            "UserComment5",
            "UserComment6",
            "UserComment7",
            "UserComment8",
            "UserComment9",
            "UserComment10",
            "UserComment11",
            "UserComment12",
            "UserComment13",
            "UserComment14",
            "UserComment15",
            "UserComment16",
            "UserComment17",
            "UserComment18",
            "UserComment19",
            "UserComment20",
          ],
        },

        gridData: {
          gridOptions: {
            dataSource: {
              // endpoint: "PickingSlipDetail",
              // filter: `(SalesOrderCode eq ${this.baseView.id}) and ((Status eq 'A') or (Status eq 'I'))`,
              // filter: [
              //   ["SalesOrderCode", "=", parseInt(this.baseView.id)],
              //   "and",
              //   [["Status", "=", "A"], "or", ["Status", "=", "I"]],
              // ],
              // expand: "Product",
              serverPaging: true,
              allowGrouping: false,
              // expand: "SaleItem",
              postProcessCallback: this.PostProcess,
              localDataList: true,
              items: this.despatchOrderLocalDataList,
            },
            noDataMessage: {
              // this `review` is one of the options in the grid toolbar dropdown that represents 'Review', 'ProductList' 'CustomerList'
              review: {
                addNew: {
                  class: "add-new",
                  title: "No Order Lines",
                  message: "Get Started, Add a PO Line",
                },
              },
              addNew: {
                class: "add-new",
                title: "No Order Lines",
                message: "Get Started, Add a PO Line",
              },
            },
            // options: {
            //   onContentReadyCallBack: this.onContentReadyCallBack,
            // },
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: true,
            review: true,
            customButtons: [
              {
                icon: "plus",
                label: "Add Item",
                visible: FeatureStorage.checkPermission(
                  "DespatchOrderDetailAddItem",
                  "edit"
                ),
                clickAction: () => {
                  this.enableAddSalesOrderItem();
                },
                buttonLocation: "left",
              },
            ],
          },
          childGridOptions: {
            visibleAutoBatch: true,
          },
          childColumns: [
            {
              screenField: "ProductBatch",
              cellTemplate: "SelectField",
              customFilter: (data) => {
                return [
                  ["ItemCode", "=", data.data.ItemCode],
                  ["BranchCode", "=", data.data.BranchCode],
                  ["SourceTransactionType", "=", ""],
                  ["SourceTransactionNo", "=", 0],
                  ["SourceTransactionLine", "=", 0],
                  ["SourceTransactionProcessCode", "=", ""],
                ];
              },

              dataSourceConfig: {
                customData: (row, parentRow) => {
                  var data = this.allBatchData.filter(
                    (x) =>
                      x.ItemCode == parentRow.data.ItemCode &&
                      x.BranchCode == parentRow.data.BranchCode
                  );

                  // return items;

                  let foundInAllocatedBatches = [];
                  if (data.length > 0) {
                    data.forEach((record, i) => {
                      let found = parentRow.data.ChildDataSource_COPY.find(
                        (x) =>
                          x.BranchCode == record.BranchCode &&
                          x.CompanyCode == record.CompanyCode &&
                          x.ItemCode == record.ItemCode &&
                          x.SupplierCode == record.SupplierCode &&
                          x.BatchNo == record.BatchNo
                      );

                      if (found) {
                        data[i] = found;
                        foundInAllocatedBatches.push(found);
                      }
                    });
                  }

                  parentRow.data.ChildDataSource_COPY.forEach((element) => {
                    let found = foundInAllocatedBatches.find(
                      (x) =>
                        x.BranchCode == element.BranchCode &&
                        x.CompanyCode == element.CompanyCode &&
                        x.ItemCode == element.ItemCode &&
                        x.SupplierCode == element.SupplierCode &&
                        x.BatchNo == element.BatchNo
                    );

                    if (!found) {
                      data.push(element);
                    }
                  });
                  return data;
                },
              },
              editorOptions: {
                onOpened: (e, rowData, parentRow) => {
                  e.component.beginUpdate();

                  var items = e.component.getDataSource().items();
                  items.forEach((item) => {
                    item.disabled = false;

                    e.component.option("items", items);
                  });

                  parentRow.data.ChildDataSource.forEach((element) => {
                    items.forEach((item, index) => {
                      if (element.BatchNo == item.BatchNo) {
                        items[index].disabled = true;
                        e.component.option("items", items);
                      }
                    });
                  });
                  e.component.endUpdate();
                },
              },
              dropDownOptions: {
                width: 300,
              },
              // gridDataField: "BatchNo",
              // allowEditing: false,
              // showEditorAlways: false,
              // cellTemplate: "EditableText",
            },
            {
              screenField: "Supplier",
              dataField: "SupplierName",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "SupplierName",
                  },
                ],
                secondary: [
                  {
                    dataField: "SupplierCode",
                  },
                ],
              },
            },
            {
              screenField: "UseByDate",
            },
            {
              screenField: "Quantity",
              dataField: "AvailableQty",
              label: "Available",
            },
            {
              screenField: "Quantity",
              label: "Stock UM Quantity",
              dataField: "Qty",
              type: "EditableDecimal",
              showEditorAlways: true,
              makeDisabled: (data) => {
                // if (data.data.InvoiceTy
                if (data) return !data.data.BatchNo;
                else return true;
              },
            },
            {
              dataField: "ActionDelete",
              label: "",
              width: 50,
              minWidth: 50,
              cellTemplate: "ActionDelete",
            },
            {
              dataField: "ActionAddNew",
              label: "",
              width: 50,
              minWidth: 50,
              cellTemplate: "ActionAddNew",
            },
          ],
          columns: [
            {
              screenField: "CheckInclude",
              allowEditing: false,
              defaultValue: false,
              valueChangeCallBack: this.checkBoxValueChange,
              allowHiding: false,
              showInColumnChooser: false,
              fixed: true,
              fixedPosition: "left",
              label: "",
              width: 50,
              minWidth: 50,
              visible: this.baseView.mode == "edit",
              cssClass: "check-include",
            },
            {
              screenField: "ProductItem",
              label: "Product / Account",
            },
            {
              screenField: "SalesUM",
              width: 80,
              minWidth: 80,
            },
            {
              screenField: "SalesUMNetFXPrice",
              label: "Price",
              format: "Decimal-16-4C",
              width: 110,
              minWidth: 110,
            },
            {
              screenField: "GrossProfitPcnt",
              dataField: "SalesUMStandardCost",
              calculateCellValue: this.calculateCellValue,
              width: 110,
              minWidth: 110,
            },
            {
              screenField: "Quantity",
              label: "Outstanding",
              dataField: "SalesUMBackorderQty",
              format: "Decimal-16-4",
              width: 110,
              minWidth: 110,
            },
            {
              screenField: "Quantity",
              label: "Picked",
              dataField: "SalesUMPickedQty",
              type: "EditableDecimal",
              format: "Decimal-16-4",
              showEditorAlways: true,
              allowSearch: false,
              allowSorting: false,
              allowFiltering: false,
              width: 110,
              minWidth: 110,
              minmax: { max: 999999.0 },
              makeDisabled: (data) => {
                if (data.data.IsBatchProduct == "No") {
                  return false;
                } else return true;
              },
            },
            {
              screenField: "StockUM",
              dataField: "UnitOfMeasureCode",
              width: 80,
              minWidth: 80,
              // allowSearch: false,
              // allowSorting: false,
              // allowFiltering: false,
            },
            {
              screenField: "StockUMPickedQty",
              label: "Stock UM Picked",
              dataField: "StockUMQuantityToPick",
              type: "EditableDecimal",
              format: "Decimal-16-4",
              showEditorAlways: true,
              allowSearch: false,
              allowSorting: false,
              allowFiltering: false,
              width: 110,
              minWidth: 110,
              minmax: { max: 999999.0 },
              makeDisabled: (data) => {
                if (data.data.SalesUMIsVariable) {
                  return false;
                } else return true;
              },
            },
            {
              screenField: "IsDefault",
              gridDataField: "Completed",
              label: "Complete",
              cellTemplate: "CheckBoxTemplate",
              width: 100,
              cssClass: "column-checkBox",
              allowSorting: false,
              allowSearch: false,
              makeReadOnly: (data) => {
                return (
                  data.data.SalesUMPickedQty >= data.data.SalesUMBackorderQty
                );
              },
              // / data.data.SalesUMPickedQty >= data.data.SalesUMBackorderQty
            },
            {
              screenField: "GridRecordEllipsisMenu",
              allowSearch: false,
              cssClass: "padding-7",
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Item Price Update",
                      data: data,
                      clickAction: this.enableItemPriceUpdate,
                    },
                    {
                      menuText: "Despatch Data",
                      data: data,
                      visible: FeatureStorage.checkPermission(
                        "AlmondcoDespatchData",
                        "create"
                      ),
                      clickAction: this.enableAlmondcoDespatchData,
                    },
                    {
                      menuText: "Edit Item",
                      clickAction: this.enableEditProductItem,
                      visible: FeatureStorage.checkPermission(
                        "DespatchOrderDetailEditPrice",
                        "edit"
                      ),
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              // makeDisabled: (data) => {
              //   // if (data.data.InvoiceTy
              //   if (data) return data.data.FriendlyActive != "Active";
              // },
            },
          ],
          valueChangedEventListners: [
            {
              dataField: "SalesUMPickedQty",
              listner: (e, lineData) => {
                lineData.data.SalesUMPickedQty = e.value;
                // Do not recalculate StockUMQuantityToPick only when SalesUMIsVariable is true
                if (!lineData.data.SalesUMIsVariable) {
                  lineData.data["StockUMQuantityToPick"] =
                    lineData.data["SalesUMPickedQty"] *
                    lineData.data["SalesUMConversion"];
                }
                let backOrderValue = lineData.data.SalesUMBackorderQty;

                if (e.value >= backOrderValue) {
                  lineData.data.Completed = true;
                }
                if (lineData.data.SalesUMPickedQty > 0) {
                  lineData.data.CheckInclude = true;
                } else {
                  lineData.data.Completed = false;
                }

                if (
                  lineData.data.SalesUMPickedQty <
                  lineData.data.SalesUMBackorderQty
                )
                  lineData.data.Completed = false;
                if (lineData.data.Qty > 0) {
                  lineData.data.CheckInclude = true;
                }
                this.updateHeaderCheckBox(
                  lineData.component.getDataSource().items()
                );

                this.configReview(lineData);
              },
            },
            {
              dataField: "StockUMQuantityToPick",
              listner: (e, lineData) => {
                lineData.data.StockUMQuantityToPick = e.value;

                // Do not recalculate SalesUMPickedQty only when SalesUMIsVariable is true
                if (!lineData.data.SalesUMIsVariable) {
                  lineData.data.SalesUMPickedQty = (
                    lineData.data.StockUMQuantityToPick /
                    lineData.data.SalesUMConversion
                  ).roundNumber(4);

                  if (
                    lineData.data.SalesUMPickedQty <
                    lineData.data.SalesUMBackorderQty
                  ) {
                    lineData.data.Completed = false;
                  } else {
                    lineData.data.Completed = true;
                  }
                }

                this.configReview(lineData);
                this.$refs["despatch-order"].$refs[
                  "transactionGrid"
                ].gridRefresh();
              },
            },
            {
              dataField: "Completed",
              listner: (e, lineData) => {
                lineData.data.Completed = e.value;
                this.configReview(lineData);
              },
            },
            // Child Grid Actions

            {
              dataField: "BatchNo",
              listner: (e, lineData, parentRow) => {
                lineData.data.AllocatedQty = e.itemData.AllocatedQty;
                lineData.data.AvailableQty = e.itemData.AvailableQty;
                lineData.data.BatchNo = e.itemData.BatchNo;
                lineData.data.BranchCode = e.itemData.BranchCode;
                lineData.data.CompanyCode = e.itemData.CompanyCode;
                lineData.data.ItemCode = e.itemData.ItemCode;
                lineData.data.OnHand = e.itemData.OnHand;
                lineData.data.Qty = e.itemData.AllocatedQty;
                lineData.data.SalesOrderCode = e.itemData.SalesOrderCode;
                lineData.data.SalesOrderLineNo = e.itemData.SalesOrderLineNo;
                lineData.data.SupplierBatchNo = e.itemData.SupplierBatchNo;
                lineData.data.SupplierCode = e.itemData.SupplierCode;
                lineData.data.SupplierName = e.itemData.SupplierName;
                lineData.data.UseByDate = e.itemData.UseByDate;
                parentRow.data.CheckInclude = true;

                parentRow.data.SalesUMPickedQty += e.itemData.AllocatedQty;

                if (
                  parentRow.data.SalesUMPickedQty ==
                  parentRow.data.SalesUMBackorderQty
                )
                  parentRow.data.Completed = true;

                this.configReview(lineData);
                this.$refs["despatch-order"].$refs[
                  "transactionGrid"
                ].gridRefresh();
              },
            },
            {
              dataField: "Qty",
              listner: (e, lineData, gridItems, grid, parentRow) => {
                this.onQTYChange(e, lineData, gridItems, grid, parentRow);

                this.configReview(lineData);
              },
            },
            {
              dataField: "ActionDelete",
              listner: (e, lineData, lineParent) => {
                this.deleteChildRowData(e, lineData, lineParent);
              },
            },
            {
              dataField: "ActionAddNew",
              listner: (e, lineData, lineParent) => {
                if (e && lineData) {
                  lineParent.data.ChildDataSource.push({
                    AllocatedQty: 0,
                    AvailableQty: 0,
                    BatchNo: undefined,
                    BranchCode: undefined,
                    CompanyCode: undefined,
                    ItemCode: undefined,
                    OnHand: undefined,
                    Qty: undefined,
                    SalesOrderCode: undefined,
                    SalesOrderLineNo: undefined,
                    SupplierBatchNo: undefined,
                    SupplierCode: undefined,
                    SupplierName: undefined,
                    UseByDate: undefined,
                  });
                  this.$refs["despatch-order"].$refs[
                    "transactionGrid"
                  ].gridRefresh();
                }
              },
            },
          ],
          // ellipsisColumn: {
          //   items: [
          //     {
          //       label: "Item Price Update",
          //       clickAction: this.enableItemPriceUpdate,
          //     },
          //     {
          //       label: "Despatch Data",
          //       // data: data,
          //       visible: FeatureStorage.checkPermission(
          //         "AlmondcoDespatchData",
          //         "create"
          //       ),
          //     },
          //   ],
          //   keyExpr: "label",
          //   displayExpr: "label",
          // },
        },
        footerData: {
          footerItems: [
            {
              screenField: "SalesUMItemCount",
              dataField: "SalesUMPickedQty",
              label: "Total Picked",
              location: "left",
              value: 0,
              fieldType: "custome-string",
              customCalc: (headerData, gridItems) => {
                var total = 0;
                gridItems.forEach((element) => {
                  if (element.CheckInclude) total = total + element.FXAmount;
                });
                // return total + headerData.FXFreight + headerData.GstAmount;

                let totalPickedQty = 0;
                let totalBackOrderQty = 0;
                gridItems.forEach((el) => {
                  totalPickedQty += Number(el.SalesUMPickedQty);
                  totalBackOrderQty += Number(el.SalesUMBackorderQty);
                });

                return (
                  totalPickedQty.toFixed(2) +
                  " / " +
                  totalBackOrderQty.toFixed(2)
                );
              },
            },
          ],
        },
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          headerFormSplitView: true,
          // headerFormVisible: false,
          deliveryAddressItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  dataField: "DeliveryAddressCompanyName",
                  editorType: "dxTextBox",
                  label: {
                    text: "Name",
                  },
                  editorOptions: {
                    maxLength: "100",
                    // readOnly:
                    //   this.model.Status === "C" ||
                    //   this.model.Status === "X" ||
                    //   (this.model.Status === "A" && this.model.GoodsIn),
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressStreetLine1",
                  dataField: "DeliveryAddressStreetLine1",
                  editorOptions: {
                    maxLength: "50",
                    // readOnly:
                    //   this.model.Status === "C" ||
                    //   this.model.Status === "X" ||
                    //   (this.model.Status === "A" && this.model.GoodsIn),
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressStreetLine2",
                  dataField: "DeliveryAddressStreetLine2",
                  editorOptions: {
                    maxLength: "50",
                    // readOnly:
                    //   this.model.Status === "C" ||
                    //   this.model.Status === "X" ||
                    //   (this.model.Status === "A" && this.model.GoodsIn),
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressSuburb",
                  dataField: "DeliveryAddressSuburb",
                  editorOptions: {
                    maxLength: "50",
                    // readOnly:
                    //   this.model.Status === "C" ||
                    //   this.model.Status === "X" ||
                    //   (this.model.Status === "A" && this.model.GoodsIn),
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressState",
                  dataField: "DeliveryAddressState",
                  editorOptions: {
                    maxLength: "50",
                    // readOnly:
                    //   this.model.Status === "C" ||
                    //   this.model.Status === "X" ||
                    //   (this.model.Status === "A" && this.model.GoodsIn),
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressPostcode",
                  dataField: "DeliveryAddressPostcode",
                  editorOptions: {
                    maxLength: "50",
                    // readOnly:
                    //   this.model.Status === "C" ||
                    //   this.model.Status === "X" ||
                    //   (this.model.Status === "A" && this.model.GoodsIn),
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressCountry",
                  dataField: "DeliveryAddressCountry",
                  editorOptions: {
                    maxLength: "50",
                    // readOnly:
                    //   this.model.Status === "C" ||
                    //   this.model.Status === "X" ||
                    //   (this.model.Status === "A" && this.model.GoodsIn),
                  },
                  // allowUpdate: false,
                },
              ],
            },
          ],
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DateIn",
                      editorOptions: {
                        value:
                          this.baseView.mode != "review"
                            ? new Date()
                            : undefined,
                      },
                      required: this.baseView.mode != "review",
                    },
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 2,
                      items: [
                        {
                          screenField: "RequiredDate",
                          dataField: "RequiredByDate",
                          allowUpdate: false,
                          cssClass: "Required_Date",
                          label: {
                            text: "Reqd Date",
                          },
                        },
                        {
                          screenField: "ShipDate",
                          allowUpdate: false,
                        },
                      ],
                    },
                    {
                      screenField: "ConNote",
                      dataField: "ConsignmentNo",
                    },
                    {
                      screenField: "CustPO",
                      dataField: "OrderNo",
                      allowUpdate: false,
                    },
                    {
                      itemType: "group",
                      caption: "",
                      // colCount: 2,
                      cssClass: "deliver-to",
                      items: [
                        {
                          screenField: "DeliverTo",
                          dataField: "DeliveryAddressCompanyName",

                          onItemClick: this.setDeliverTo,
                          ref: "DeliveryAddressCompanyName",
                          // displayExpr: (data) => {
                          //   return data.DeliveryAddressCompanyName;
                          // },
                          acceptCustomValue: true,
                          onCustomItemCreating: (data) => {
                            if (!data.text) {
                              return;
                            } else {
                              this.deliverToCustomItem(data);
                            }
                          },
                        },
                        {
                          screenField: "DeliveryCompanyView",
                          editAddress:
                            this.baseView.mode != "review" ? true : false,
                        },
                      ],
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      // screenField: "Branch",
                      label: {
                        text: "Branch",
                      },
                      dataField: "BranchName",
                      allowUpdate: false,
                      // editorOptions: {
                      //   // onItemClick: this.onBranchCodeValueChanged.bind(this),
                      // },
                    },
                    {
                      // screenField: "Division",
                      label: {
                        text: "Division",
                      },
                      dataField: "DivisionName",
                      allowUpdate: false,
                      // editorOptions: {
                      //   // onItemClick: this.onDivisionCodeValueChanged.bind(this),
                      // },
                    },
                    {
                      screenField: "OrderType",
                      dataField: "SalesOrderTypeDescription",
                      allowUpdate: false,
                    },
                    {
                      screenField: "SalesRep",
                      allowUpdate: false,
                    },

                    {
                      screenField: "Currency",
                      dataField: "Currency",
                      allowUpdate: false,
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            // Credit # [CreditNote] for Invoice # [InvoiceNumber]
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: "SalesOrderCode",
                text: "Create Delivery for Sales Order # ",
              },
              secondary: {
                dataField: undefined,
                text: undefined,
              },
            },
            secondary: {
              dataField: "CustomerName",
              text: undefined,
            },
          },
        },
      };
    },

    getHeaderToolbar() {
      return {
        headerToolbar: {
          // screenName: "Purchase Orders - All",
          audit: this.baseView.mode == "review",
          status: false,
          notes: false,
          save: true,
          saveCallback: this.saveDespatchOrder,
          commentsTitle: "Sales Order Comments",
          commentsAsForm: true,
          // toolbarFormItems: [
          //   {
          //     dataField: "CustomerName",
          //     allowUpdate: false,
          //     editorOptions: {
          //       width: 300,
          //       placeholder: "Customer Name",
          //     },
          //     label: {
          //       text: "Customer",
          //       visible: false,
          //     },
          //   },
          //   // },
          // ],
          toolbarAfterFormItems: [
            {
              screenField: "Inactive",
              dataField: "ProcessInvoice",
              editorType: "dxSwitch",
              label: {
                text: "Process Invoice",
              },
              visible:
                this.processInvoiceSettingValue == "D" ||
                this.processInvoiceSettingValue == "U"
                  ? false
                  : true,
            },
          ],

          customButtons: [
            {
              label: "save",
              icon: "..",
              type: " ",
              click: "",
              menu: [
                {
                  label: "Credit Comments",
                  clickAction: "",
                },
              ],
            },
          ],
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    // // disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    // disabled: true,
                  },
                },
              ],
            },
          ],
          orderComments: {
            dataField: "SalesOrderTypeCode",
            endpoint: "SalesOrderType",
            toMatch: [
              "UserComment1",
              "UserComment2",
              "UserComment3",
              "UserComment4",
              "UserComment5",
              "UserComment6",
              "UserComment7",
              "UserComment8",
              "UserComment9",
              "UserComment10",
              "UserComment11",
              "UserComment12",
              "UserComment13",
              "UserComment14",
              "UserComment15",
              "UserComment16",
              "UserComment17",
              "UserComment18",
              "UserComment19",
              "UserComment20",
            ],
          },
          commentItems: [
            {
              itemType: "group",
              caption: "",
              items: [],
            },
          ],

          ellipsis: {
            // menuItems: this.cancelCompleteMenu,
            visible: this.baseView.mode == "review",
            clickAction: (e) => {
              if (e.itemData.menuText == "Cancel Order") {
                // this.cancelOrder();
              } else {
                // this.completeOrder();
              }
            },
            disabled: !FeatureStorage.checkPermission(
              "PurchaseOrder",
              "create"
            ),
          },
        },
      };
    },
    getDataModel() {
      return this.model;
    },
  },
  beforeCreate() {
    this.$store.dispatch("defaultUserSettings/setDefaultCompanyBranchDivision");
  },
  methods: {
    async getDespatchOrderDetails(updated) {
      var batchProdCodes = [];
      await DespatchOrderService.getDespatchOrderDetailsByCode(
        this.baseView.id,
        {
          select: [
            "ItemCode",
            "ItemDescription",
            "SalesUM",
            "UnitOfMeasureCode",
            "SalesUMBackorderQty",
            "SalesUMStandardCost",
            "SalesUMNetFXPrice",
            "IsBatchProduct",
            "LineNo",
            "SalesOrderCode",
            "SalesUMConversion",
            "SalesUMIsVariable",
          ],
        }
      )
        .then((res) => {
          this.despatchOrderLocalDataList = res.data.value;
          this.despatchOrderLocalDataList.forEach((element) => {
            if (element.IsBatchProduct != "No")
              batchProdCodes.push(element.ItemCode);
          });
        })
        .catch((err) => {
          this.setLoading = false;
          this.serverError = {
            err: err,
            msg: "despatch order failed",
            time: new Date().getTime(),
          };
        });

      if (batchProdCodes.length != 0) {
        var filter = undefined;
        batchProdCodes.forEach((element) => {
          if (!filter) filter = `ItemCode eq '${element}'`;
          else filter = filter + ` or ItemCode eq '${element}'`;
        });

        await ProductBatchService.getAllBatchNo(filter, {
          select: [
            "ItemCode",
            "BranchCode",
            "SourceTransactionType",
            "SourceTransactionNo",
            "SourceTransactionLine",
            "SourceTransactionProcessCode",
            "CompanyCode",
            "SupplierCode",
            "SupplierName",
            "BatchNo",
            "AllocatedQty",
            "AvailableQty",
            "OnHand",
            "UseByDate",
          ],
        })
          .then((res) => {
            this.allBatchData = res.data.value;
            this.setLoading = false;
            this.loaded = true;
          })
          .catch((err) => {
            this.setLoading = false;
            this.serverError = {
              err: err,
              msg: "despatch order failed",
              time: new Date().getTime(),
            };
          });
      } else {
        this.setLoading = false;
        this.loaded = true;
      }

      if (updated) {
        this.refreshDataGrid = true;
        setTimeout(() => {
          this.refreshDataGrid = false;
        }, 10);

        // this.$refs["despatch-order"].$refs["transactionGrid"].gridRepaint2();
      }
    },
    async enableAlmondcoDespatchData(data) {
      // this.setLoading = true;
      this.$store.dispatch("dataContext/setAllowDataContext", false);

      data.StockUMSuppliedQty = data.StockUMQuantityToPick;

      this.almondcoDespatchData = {
        // localItems: res.data.value,
        visible: true,
        popUpCallBack: this.popUpCallBack,
        data: data,
        model: this.$refs["despatch-order"].getTransactionData(),
      };
    },
    enableEditProductItem(data) {
      this.editProductItem = {
        visible: true,
        editProductItemData: data,
        popUpCallBack: this.popUpCallBack,
        model: this.$refs["despatch-order"].getTransactionData(),
      };
    },
    enableAddSalesOrderItem() {
      this.addSalesOrderItem = {
        visible: true,
        addSalesOrderItemData:
          this.$refs["despatch-order"].getTransactionData(),
        popUpCallBack: this.popUpCallBack,
      };
    },
    configReview(lineData) {
      var index = this.reviewDataSource.findIndex(
        (x) => x.ItemCode == lineData.data.ItemCode
      );
      if (index != -1) {
        this.removeFromReview(index);
      }
      this.addToReview(lineData.data);
      this.$refs["despatch-order"].$refs["transactionGrid"].gridRefresh();
      // this.$refs["despatch-order"].$refs["transactionGrid"].gridRepaint2();
    },
    removeFromReview(index) {
      this.reviewDataSource.splice(index, 1);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },
    addToReview(item) {
      this.reviewDataSource.push(item);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },
    async getProcessInvoiceSetting() {
      var processInvoiceSetting = CacheService.getCache(
        "ProcessInvoiceToggle_Setting"
      );

      if (!processInvoiceSetting)
        await SettingsService.getBySettingName("ProcessInvoiceToggle").then(
          (res) => {
            if (res.data.value.length > 0) {
              this.processInvoiceSettingValue = res.data.value[0].SettingValue;

              CacheService.saveCache(
                "ProcessInvoiceToggle_Setting",
                res.data.value[0],
                15
              );
            }
          }
        );
      else this.processInvoiceSettingValue = processInvoiceSetting.SettingValue;
    },
    onQTYChange(e, lineData, gridItems, grid, parentRow) {
      if (!e.event) return;
      lineData.data.Qty = e.value;

      var availableQty =
        lineData.data.AvailableQty + lineData.data.AllocatedQty;

      if (availableQty < e.value) {
        if (parentRow.data.ItemDescription) {
          this.validationSummary = [];
          this.validationSummary.push({
            message: `${parentRow.data.ItemDescription} only has ${availableQty} left to pick.  Please enter in a picked quantity that is ${availableQty} or less.`,
          });

          lineData.data.Qty = availableQty;
          e.component.beginUpdate();
          e.component.option("value", availableQty);
          e.component.endUpdate();
        }
      } else {
        lineData.data.Qty = e.value;
      }

      var total = 0;
      parentRow.data.ChildDataSource.forEach((element) => {
        total = total + element.Qty;
      });

      gridItems.forEach((element) => {
        if (
          element.ItemCode == parentRow.data.ItemCode &&
          element.LineNo == parentRow.data.LineNo
        ) {
          if (total > 0) element.CheckInclude = true;
          else element.CheckInclude = false;
        }
      });

      parentRow.data.StockUMQuantityToPick = total;
      parentRow.data.SalesUMPickedQty =
        total / parentRow.data.SalesUMConversion;

      if (parentRow.data.SalesUMPickedQty >= parentRow.data.SalesUMBackorderQty)
        parentRow.data.Completed = true;
      else parentRow.data.Completed = false;
    },
    async deleteChildRowData(e, lineData, lineParent) {
      let confirmDelete = await this.$confirm(
        "Are you sure you want to delete this record?",
        "Delete"
      );

      if (confirmDelete && e) {
        if (!lineData.data.Qty) lineData.data.Qty = 0;
        lineParent.data.StockUMQuantityToPick -= lineData.data.Qty;
        lineParent.data.Completed = false;
        lineParent.data.ChildDataSource.splice(lineData.rowIndex, 1);

        var childItems = lineParent.data.ChildDataSource;

        var total = 0;
        childItems.forEach((element) => {
          total = total + element.Qty;
        });
        lineParent.data.SalesUMPickedQty =
          total / lineParent.data.SalesUMConversion;
        if (lineParent.data.ChildDataSource.length == 0) {
          lineParent.data.ChildDataSource.push({
            AllocatedQty: 0,
            AvailableQty: 0,
            BatchNo: undefined,
            BranchCode: undefined,
            CompanyCode: undefined,
            ItemCode: undefined,
            OnHand: undefined,
            Qty: undefined,
            SalesOrderCode: undefined,
            SalesOrderLineNo: undefined,
            SupplierBatchNo: undefined,
            SupplierCode: undefined,
            SupplierName: undefined,
            UseByDate: undefined,
          });
        }

        this.$refs["despatch-order"].$refs["transactionGrid"].gridRefresh();
      }
    },
    async checkBoxValueChange(fieldData, recordData) {
      if (!fieldData.event) return;

      var gridItems = recordData.component.getDataSource().items();

      if (recordData.rowType == "header") {
        if (fieldData.value == undefined) return;
        else {
          gridItems.forEach((element) => {
            if (fieldData.value) {
              element.CheckInclude = true;
              element.Completed = true;
              element.SalesUMPickedQty = element.SalesUMBackorderQty;
              element.StockUMQuantityToPick =
                element.SalesUMPickedQty * element.SalesUMConversion;
            } else {
              element.CheckInclude = false;
              element.Completed = false;
              element.SalesUMPickedQty = 0;
              element.StockUMQuantityToPick = 0;
            }
          });
        }
      } else {
        recordData.data.CheckInclude = fieldData.value;
        if (!fieldData.value) recordData.data.StockUMQuantityToPick = 0;
        else {
          recordData.data["Completed"] = true;
          recordData.data["SalesUMPickedQty"] =
            recordData.data["SalesUMBackorderQty"];
          recordData.data["StockUMQuantityToPick"] =
            recordData.data["SalesUMPickedQty"] *
            recordData.data["SalesUMConversion"];
        }
      }
      if (fieldData.value == false && recordData.rowType != "header") {
        recordData.data["SalesUMPickedQty"] = 0;
        recordData.data["Completed"] = false;
        recordData.data["StockUMQuantityToPick"] = 0;
        recordData.data.Qty = 0;
        var ods = null;
        if (recordData.data.ChildDataSource) {
          recordData.data.ChildDataSource.forEach((element) => {
            element.Qty = 0;
            element.AllocatedQty = 0;
          });
          ods = recordData.data.ChildDataSource;
        }

        recordData.data.ChildDataSource = [];
        recordData.data.ChildDataSource = ods;
      }

      var gridInstance =
        this.$refs[
          "despatch-order"
        ].$refs.transactionGrid.getDataSourceInstance();
      gridInstance.refresh();

      this.updateHeaderCheckBox(gridItems);
    },

    updateHeaderCheckBox(gridItems) {
      if (!this.$refs["despatch-order"].$refs["transactionGrid"]) return;
      if (
        !this.$refs["despatch-order"].$refs["transactionGrid"].$refs[
          "cx-CheckInclude"
        ]
      )
        return;
      var refHeadInstance =
        this.$refs["despatch-order"].$refs["transactionGrid"].$refs[
          "cx-CheckInclude"
        ].getSeletcAllRef().instance;

      var checkBoxHeader = refHeadInstance.element();
      var getInstanceHeader = CheckBox.getInstance(checkBoxHeader);

      let count = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) count = count + 1;
      });

      setTimeout(() => {
        if (count > 0 && count != gridItems.length) {
          getInstanceHeader.option("value", undefined);
        } else if (count == 0) {
          getInstanceHeader.option("value", false);
        } else if (count == gridItems.length) {
          getInstanceHeader.option("value", true);
        }

        this.$refs["despatch-order"].$refs["transactionGrid"].gridRefresh();
      }, 200);
    },
    async saveDespatchOrder(data, gridItems) {
      this.validationSummary = [];
      let payload = {
        DateIn: new Date(data.DateIn).toSaveDate(),
        ProcessInvoice: data.ProcessInvoice ? "Y" : "N",
        PartDeliver: data.PartDeliver ? "Y" : "N",
        BackOrder: data.BackOrder ? "Y" : "N",
        DeliveryAddressCompanyName: data.DeliveryAddressCompanyName,
        DeliveryAddressCountry: data.DeliveryAddressCountry,
        DeliveryAddressPostcode: data.DeliveryAddressPostcode,
        DeliveryAddressState: data.DeliveryAddressState,
        DeliveryAddressStreetLine1: data.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: data.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: data.DeliveryAddressSuburb,
        ConsignmentNo: data.ConsignmentNo,
        SalesOrderCode: data.SalesOrderCode,
        UserComment1: data.UserComment1,
        UserComment10: data.UserComment10,
        UserComment11: data.UserComment11,
        UserComment12: data.UserComment12,
        UserComment13: data.UserComment13,
        UserComment14: data.UserComment14,
        UserComment15: data.UserComment15,
        UserComment16: data.UserComment16,
        UserComment17: data.UserComment17,
        UserComment18: data.UserComment18,
        UserComment19: data.UserComment19,
        UserComment2: data.UserComment2,
        UserComment20: data.UserComment20,
        UserComment3: data.UserComment3,
        UserComment4: data.UserComment4,
        UserComment5: data.UserComment5,
        UserComment6: data.UserComment6,
        UserComment7: data.UserComment7,
        UserComment8: data.UserComment8,
        UserComment9: data.UserComment9,
        PickingSlipDetails: [],
        ScreenName: "Order Despatch Console",
      };

      gridItems.forEach((el) => {
        if (!el.CheckInclude) return;
        let obj = {
          BatchStockTolerance: el.BatchStockTolerance, //
          Completed: el.Completed ? "Y" : "N", //
          ItemCode: el.ItemCode,
          LineNo: el.LineNo,
          SalesUM: el.SalesUM,
          SalesUMConversion: el.SalesUMConversion,
          SalesUMInvoiceConversion: el.SalesUMConversion,
          SalesUMIsVariable: el.SalesUMIsVariable,
          SalesUMQuantityToPick: el.SalesUMPickedQty, //
          StockUM: el.UnitOfMeasureCode,
          StockUMQuantityToPick: el.StockUMQuantityToPick,

          // el.SalesUMPickedQty *
          // (el.SalesUMConversion == 0 ? 1 : el.SalesUMConversion),
          StockUMSuppliedQty: el.StockUMQuantityToPick,
          PickingSlipProductBatches: [],
          AlmondcoWriteDespatchData: el.AlmondcoWriteDespatchData
            ? el.AlmondcoWriteDespatchData
            : undefined,
        };

        if (el.ChildDataSource) {
          let validBatches = el.ChildDataSource.filter((b) => {
            return b.BatchNo !== "" && b.Qty > 0;
          });

          validBatches.forEach((i) => {
            let salesUmConversion =
              el.SalesUMConversion == 0 ? 1 : el.SalesUMConversion;

            let objBatch = {
              BatchNo: i.BatchNo,
              SalesUMInvoiceConversion: el.SalesUMConversion,
              SalesUMQuantityToPick: i.Qty / salesUmConversion,
              StockUMQuantityToPick: i.Qty,
              SupplierCode: i.SupplierCode,
            };
            obj.PickingSlipProductBatches.push(objBatch);
          });
        } else {
          delete obj.PickingSlipProductBatches;
        }

        payload.PickingSlipDetails.push(obj);
      });

      if (payload.PickingSlipDetails.length == 0) {
        this.validationSummary.push({
          message: "No line item has been selected",
        });
      } else {
        this.setLoading = true;
        await DespatchOrderService.saveDespatchOrder(payload)
          .then((res) => {
            this.setLoading = false;

            this.$notify(
              `Sales Order ${res.data.SalesOrderCode} despatched successfully`,
              "success"
            );

            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: `/despatch-order`,
            });
          })
          .catch((error) => {
            this.serverError = {
              err: error,
              msg: "Despatch save failed",
              time: new Date().getTime(),
            };

            this.setLoading = false;
          });
      }
    },
    enableItemPriceUpdate(data) {
      this.itemPriceUpdate = {
        visible: true,
        popUpCallBack: this.popUpCallBack,
        itemPriceUpdateData: data,
        model: this.$refs["despatch-order"].getTransactionData(),
      };
    },
    popUpCallBack(updated) {
      this.setLoading = false;
      this.$store.dispatch("dataContext/setAllowDataContext", true);
      if (this.itemPriceUpdate) this.itemPriceUpdate.visible = false;
      this.almondcoDespatchData = undefined;
      this.editProductItem = undefined;
      this.addSalesOrderItem = undefined;
      if (updated) {
        // this.$refs["despatch-order"].$refs["transactionGrid"].gridRepaint();
        this.getDespatchOrderDetails(updated);
      }
    },
    despatchOrderPostProcess(data) {
      if (this.baseView.mode != "review") {
        data.DateIn = new Date();
      }
      data.CustomerName = data.Customer.Name;
      data.BranchName = data.Branch.Description;
      BranchCode = data.Branch.Code;
      data.BranchCode = data.Branch.Code;
      data.DivisionName = data.Division.Description;
      data.SalesOrderTypeDescription = data.SalesOrderType.Description;
      data.SalesRepresentativeFullName =
        data.SalesRepresentative.FirstName +
        " " +
        data.SalesRepresentative.Surname;
      if (this.processInvoiceSettingValue == "D") data.ProcessInvoice = false;
      else if (this.processInvoiceSettingValue == "U")
        data.ProcessInvoice = true;
      else data.ProcessInvoice = true;

      return data;
    },
    setDeliverTo(item, e) {
      item.DeliveryAddressCompanyName = e.itemData.CompanyName;
      item.DeliveryAddressStreetLine1 = e.itemData.PhysicalAddressStreetLine1;
      item.DeliveryAddressStreetLine2 = e.itemData.PhysicalAddressStreetLine2;
      item.DeliveryAddressSuburb = e.itemData.PhysicalAddressSuburb;
      item.DeliveryAddressState = e.itemData.PhysicalAddressState;
      item.DeliveryAddressPostcode = e.itemData.PhysicalAddressPostcode;
      item.DeliveryAddressCountry = e.itemData.PhysicalAddressCountry;
      item.DeliverTo = e.itemData.Code;

      if (e.component) {
        var component = e.component.instance();
        component.repaint();
      }
    },
    calculateCellValue(rowData) {
      // eslint-disable-next-line no-console
      // this.$logger.debug(rowData.SalesUMStandardCost, "rowData");
      return SalesFormulas.calculateGrossProfitPcnt(
        rowData.SalesUMStandardCost,
        rowData.SalesUMNetPrice
      );
    },
    PostProcess(data) {
      var items = [];
      // let itemCount = 0;
      let batchCount = 0;
      // let itemTotal = data.length;
      let batchTotal = data.filter((x) => x.IsBatchProduct != "No").length;

      data.forEach((element) => {
        // itemCount += 1;
        element["CheckInclude"] = false;
        element["BranchCode"] = BranchCode;

        if (element.ItemType == "G") {
          // GL Item
          element["CheckInclude"] = true;
          element["Product"] = { UnitOfMeasureCode: element["SalesUM"] };
          element["StockUM"] = element["UnitOfMeasureCode"];
          element["SalesUMPickedQty"] = element["SalesUMBackorderQty"];
          element["StockUMQuantityToPick"] = element["SalesUMPickedQty"];
          element["Completed"] = true;
        } else {
          // ItemType == 'S' (Stock Item)
          element["StockUM"] = element["UnitOfMeasureCode"];
          if (element["IsBatchProduct"] == "No") {
            element.CheckInclude = true;
            element["SalesUMPickedQty"] = element["SalesUMBackorderQty"];
            element["Completed"] = true;
          } else {
            element["SalesUMPickedQty"] = 0;
            element["ChildDataSource"] = [];
            element["Completed"] = false;
            if (element["IsBatchProduct"] == "Auto") {
              element["IsVisibleBatchData"] = true;
            }
            if (element["IsBatchProduct"] != "No") {
              if (this.$refs["despatch-order"].$refs["transactionGrid"])
                this.$refs["despatch-order"].$refs[
                  "transactionGrid"
                ].showLoading(true);

              this.setLoading = true;
              DespatchOrderService.getPickingSlipProductBatch(
                `ItemCode eq '${element["ItemCode"]}' and SalesOrderLineNo eq ${element["LineNo"]} and SalesOrderCode eq ${element["SalesOrderCode"]}`,
                {
                  select: [
                    "ItemCode",
                    "SalesOrderLineNo",
                    "SalesOrderCode",
                    "AllocatedQty",
                    "AvailableQty",
                    "BatchNo",
                    "BranchCode",
                    "CompanyCode",
                    "OnHand",
                    "SupplierCode",
                    "SupplierName",
                    "UseByDate",
                    "SupplierBatchNo",
                  ],
                }
              )
                .then((response) => {
                  batchCount += 1;
                  var totalQTY = 0;
                  element["ChildDataSource"] = response.data.value;
                  element["ChildDataSource"].forEach((batch) => {
                    batch.Qty = batch.AllocatedQty;
                    totalQTY = totalQTY + batch.AllocatedQty;
                  });
                  element["StockUMQuantityToPick"] = totalQTY;
                  element["SalesUMPickedQty"] =
                    totalQTY / element["SalesUMConversion"];

                  if (
                    element["SalesUMPickedQty"] >=
                    element["SalesUMBackorderQty"]
                  )
                    element["Completed"] = true;
                  else element["Completed"] = false;

                  element["ChildDataSource_COPY"] =
                    element["ChildDataSource"].slice();

                  if (element["ChildDataSource"].length == 0) {
                    element["ChildDataSource"].push({
                      AllocatedQty: 0,
                      AvailableQty: 0,
                      BatchNo: undefined,
                      BranchCode: undefined,
                      CompanyCode: undefined,
                      ItemCode: undefined,
                      OnHand: undefined,
                      Qty: undefined,
                      SalesOrderCode: undefined,
                      SalesOrderLineNo: undefined,
                      SupplierBatchNo: undefined,
                      SupplierCode: undefined,
                      SupplierName: undefined,
                      UseByDate: undefined,
                    });
                  }
                  if (batchCount == batchTotal) {
                    setTimeout(() => {
                      this.setLoading = false;
                      if (this.$refs["despatch-order"].$refs["transactionGrid"])
                        this.$refs["despatch-order"].$refs[
                          "transactionGrid"
                        ].showLoading(false);
                    }, 500);
                  }
                })
                .then(() => {
                  if (element["ChildDataSource"].length > 0) {
                    var Totalpicked = 0;
                    element["ChildDataSource"].forEach((row) => {
                      if (row.Qty > 0) {
                        Totalpicked = Totalpicked + row.Qty;
                        element.CheckInclude = true;
                      }
                    });
                    // element.totalPickedQty = Totalpicked;
                    // element.StockUMQuantityToPick =
                    //   Totalpicked * element.SalesUMConversion;
                    // if (Totalpicked == element["SalesUMBackorderQty"]) {
                    //   element["Completed"] = true;
                    // }
                    // if (Totalpicked < element["SalesUMBackorderQty"]) {
                    //   element["Completed"] = false;
                    // }
                  }
                });
            } else {
              element["Completed"] = false;
            }
          }
          element["StockUMQuantityToPick"] =
            element["SalesUMPickedQty"] * element["SalesUMConversion"];
        }
        var index = this.reviewDataSource.findIndex(
          (x) => x.ItemCode == element.ItemCode
        );
        if (index != -1) items.push(this.reviewDataSource[index]);
        else items.push(element);
      });

      setTimeout(() => {
        this.$store.dispatch("ui/setGridContentReady", true);
        this.updateHeaderCheckBox(items);
      }, 4000);
      return items;
    },
  },
  watch: {
    getGridContentReady(value) {
      if (value) {
        setTimeout(() => {
          this.updateHeaderCheckBox(this.despatchOrderLocalDataList);
          this.$store.dispatch("ui/setGridContentReady", false);
        }, 500);
      }
    },
  },
};
</script>

<style lang="scss">
.Required_Date {
  padding-right: 0px !important;
}
</style>
